import { createFileRoute } from "@tanstack/react-router"
import { CheckoutReturnPage } from "@/money"

// The billing_ prefix un-nests this route from billing.tsx (a page, not a
// layout); the URL stays /t/$tenantSlug/billing/checkout/$purchaseId, which
// the backend gives Stripe as the Checkout Session's return URL.
export const Route = createFileRoute(
  "/(user)/t/$tenantSlug/billing_/checkout/$purchaseId",
)({
  component: RouteComponent,
})

function RouteComponent() {
  const { tenantSlug, purchaseId } = Route.useParams()

  return <CheckoutReturnPage tenantSlug={tenantSlug} purchaseId={purchaseId} />
}
